export default __webpack_public_path__ + "static/media/masterplanss.21b3fc08.webp";